import { TextWidgetSetupType } from "../types/setups/textWidgetSetupType";

export const textWidgetSetupDefaultData: TextWidgetSetupType = {
  widgetType: "text",
  name: "Text Widget",
  text: "",
};
